import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { fetchAdminDonationsDetail, markDonationComplete } from '../../util/api';

// ================ Action types ================ //

export const FETCH_DONATIONS_REQUEST = 'app/DashboardPage/FETCH_DONATIONS_REQUEST';
export const FETCH_DONATIONS_SUCCESS = 'app/DashboardPage/FETCH_DONATIONS_SUCCESS';
export const FETCH_DONATIONS_ERROR   = 'app/DashboardPage/FETCH_DONATIONS_ERROR';

export const MARK_COMPLETE_REQUEST = 'app/DashboardPage/MARK_COMPLETE_REQUEST';
export const MARK_COMPLETE_SUCCESS = 'app/DashboardPage/MARK_COMPLETE_SUCCESS';
export const MARK_COMPLETE_ERROR   = 'app/DashboardPage/MARK_COMPLETE_ERROR';

// ================ Reducer ================ //

const initialState = {
  donations: [],
  fetchDonationsInProgress: false,
  fetchDonationsError: null,
  markCompleteInProgress: null,
  markCompleteError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_DONATIONS_REQUEST:
      return { ...state, fetchDonationsInProgress: true, fetchDonationsError: null };
    case FETCH_DONATIONS_SUCCESS:
      return { ...state, fetchDonationsInProgress: false, donations: payload };
    case FETCH_DONATIONS_ERROR:
      return { ...state, fetchDonationsInProgress: false, fetchDonationsError: payload };

    case MARK_COMPLETE_REQUEST:
      return { ...state, markCompleteInProgress: payload, markCompleteError: null };
    case MARK_COMPLETE_SUCCESS:
      return {
        ...state,
        markCompleteInProgress: null,
        donations: state.donations.map(d =>
          d.transactionId === payload ? { ...d, completed: true } : d
        ),
      };
    case MARK_COMPLETE_ERROR:
      return { ...state, markCompleteInProgress: null, markCompleteError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchDonationsRequest = () => ({ type: FETCH_DONATIONS_REQUEST });
export const fetchDonationsSuccess = donations => ({ type: FETCH_DONATIONS_SUCCESS, payload: donations });
export const fetchDonationsError = e => ({ type: FETCH_DONATIONS_ERROR, payload: storableError(e), error: true });

export const markCompleteRequest = txId => ({ type: MARK_COMPLETE_REQUEST, payload: txId });
export const markCompleteSuccess = txId => ({ type: MARK_COMPLETE_SUCCESS, payload: txId });
export const markCompleteError = e => ({ type: MARK_COMPLETE_ERROR, payload: storableError(e), error: true });

// ================ Thunks ================ //

export const loadData = () => dispatch => {
  dispatch(fetchDonationsRequest());

  return Promise.all([
    dispatch(fetchCurrentUser()),
    fetchAdminDonationsDetail()
      .then(response => {
        dispatch(fetchDonationsSuccess(response.donations));
      })
      .catch(e => {
        dispatch(fetchDonationsError(e));
      }),
  ]);
};

export const completeDonation = transactionId => dispatch => {
  dispatch(markCompleteRequest(transactionId));

  return markDonationComplete(transactionId)
    .then(() => {
      dispatch(markCompleteSuccess(transactionId));
    })
    .catch(e => {
      dispatch(markCompleteError(e));
    });
};
